export default [
    {
        path: "/signup",
        exact: true,
        ssr: false,
        component: "Hottie",
        mui: true,
    }
];